// Blackout home: countdown, and the signup that Shopify's own form can't do.
(function () {
  "use strict";

  // ---- Countdown ------------------------------------------------------
  // Reveal: Saturday 3 April 2027, 05:00 PT (Abel 2026-10-23). The section
  // setting is the source of truth; this constant only covers a blank one.
  // FALLBACK (item 1.2): the countdown markup ships `hidden` and is shown
  // only after a valid future target has produced real numbers. Any failure
  // here leaves it hidden, and the date line under it does the job alone,
  // so a broken or 00:00:00:00 countdown can never be on screen.
  var REVEAL_DEFAULT = "2027-04-03T05:00:00-07:00";
  var el = document.getElementById("countdown");
  if (el) {
    var target = new Date(el.dataset.target || REVEAL_DEFAULT).getTime();
    var cells = {
      d: el.querySelector('[data-unit="d"]'), h: el.querySelector('[data-unit="h"]'),
      m: el.querySelector('[data-unit="m"]'), s: el.querySelector('[data-unit="s"]')
    };
    var pad = function (n) { return String(n).padStart(2, "0"); };
    var timer = null;
    var tick = function () {
      var ms = target - Date.now();
      if (!isFinite(target) || ms <= 0 || !cells.d || !cells.h || !cells.m || !cells.s) {
        el.hidden = true;
        if (timer) clearInterval(timer);
        return;
      }
      var t = Math.floor(ms / 1000);
      // Digits roll in only when they change, and never on first paint.
      var put = function (c, v) {
        v = String(v);
        if (c.textContent === v) return;
        c.textContent = v;
        if (el.hidden) return;
        c.classList.remove("roll"); void c.offsetWidth; c.classList.add("roll");
      };
      put(cells.d, Math.floor(t / 86400));
      put(cells.h, pad(Math.floor((t % 86400) / 3600)));
      put(cells.m, pad(Math.floor((t % 3600) / 60)));
      put(cells.s, pad(t % 60));
      el.hidden = false;
    };
    try { tick(); timer = setInterval(tick, 1000); } catch (e) { el.hidden = true; }
  }

  // ---- Confirmation + Share (item 4.4) -------------------------------
  // The same block serves both signup paths; see the comment in
  // sections/blackout.liquid. handledBy is "api" or "fallback".
  var SHARE = { title: "SERVED", url: "https://servedofficial.com" };

  function wireShare(root) {
    var btn = root.querySelector(".share");
    var note = root.querySelector(".share-msg");
    if (!btn) return;
    var hideTimer;
    var flash = function (text) {
      if (!note) return;
      note.textContent = text;
      note.hidden = false;
      clearTimeout(hideTimer);
      hideTimer = setTimeout(function () { note.hidden = true; }, 2500);
    };
    var copy = function () {
      var done = function () { flash("Link copied"); };
      var legacy = function () {
        try {
          var ta = document.createElement("textarea");
          ta.value = SHARE.url;
          ta.setAttribute("readonly", "");
          ta.style.position = "absolute"; ta.style.left = "-9999px";
          document.body.appendChild(ta);
          ta.select();
          var ok = document.execCommand("copy");
          document.body.removeChild(ta);
          if (ok) { done(); return; }
        } catch (e) { /* fall through */ }
        flash(SHARE.url);
      };
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(SHARE.url).then(done, legacy);
      } else legacy();
    };
    btn.addEventListener("click", function () {
      if (navigator.share) {
        navigator.share(SHARE).catch(function (err) {
          // Cancelling the share sheet is not an error worth reacting to.
          if (!err || err.name !== "AbortError") copy();
        });
      } else copy();
    });
  }

  function showConfirmation(form, handledBy) {
    var tpl = document.getElementById("member-confirm");
    var node = tpl && tpl.content ? tpl.content.firstElementChild.cloneNode(true) : null;
    if (!node) {
      // Template missing: keep the old minimal confirmation rather than nothing.
      node = document.createElement("div");
      node.className = "confirm";
      node.setAttribute("role", "status");
      var p = document.createElement("p");
      p.className = "display big";
      p.textContent = "You’re in.";
      node.appendChild(p);
    }
    node.setAttribute("data-handled-by", handledBy);
    // Members never see the offer pop-up again.
    try { localStorage.setItem("srvd-member", "1"); } catch (e) { /* ignore */ }
    form.replaceWith(node);
    wireShare(node);
    try { node.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
    return node;
  }

  // The pop-up signs people up too; when it does, the page form swaps to the
  // same confirmation so nobody is asked to join twice.
  window.srvdPopupJoined = function () {
    var f = document.getElementById("member-form");
    if (f) showConfirmation(f, "popup");
  };

  // Fallback path coming back from Shopify: Liquid already rendered the block.
  var rendered = document.querySelector(".confirm[data-handled-by]");
  if (rendered) wireShare(rendered);

  // ---- Signup ---------------------------------------------------------
  // Shopify's customer form captures the email and silently drops the phone
  // number, the text consent and any member number (measured 2026-10-05).
  // When an endpoint is configured we post there instead; if that call fails
  // for any reason we let the browser submit the Shopify form, so a signup is
  // never lost — it just arrives without the extras.
  var form = document.getElementById("member-form");
  if (!form) return;

  var msg = form.querySelector(".form-msg");
  var button = form.querySelector("button[type=submit]");

  var say = function (text) {
    if (!msg) return;
    msg.textContent = text;
    msg.hidden = false;
  };

  var value = function (name) {
    var node = form.querySelector('[name="' + name + '"]');
    return node ? node.value.trim() : "";
  };

  // EITHER email or phone (Brandon 2026-10-20). Neither input is
  // `required`, because HTML cannot express "one of these two", so the
  // check lives here and again in the API. A supplied email is still
  // checked by the browser (type="email") before this handler runs.
  // Registered BEFORE the endpoint check so an empty form is stopped even
  // when no endpoint is configured. The visible "either is enough" hint
  // was removed 2026-10-22, so this message is now the only explanation.
  form.addEventListener("submit", function (event) {
    var smsBox = form.querySelector('[name="sms_consent"]');
    if (value("contact[email]")) return;
    // Phone only: without the ticked box we could never contact them, so the
    // signup would look successful and lead nowhere (Brandon 2026-10-28).
    // The box itself stays optional whenever an email is given (TCPA: consent
    // must be freely given, never a condition of joining).
    if (value("contact[phone]") && smsBox && smsBox.checked) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (value("contact[phone]")) {
      say("Tick the box to get texts, or add an email.");
      if (smsBox) smsBox.focus();
      return;
    }
    say("Add an email or a phone number.");
    var firstField = form.querySelector('[name="contact[email]"]');
    if (firstField) firstField.focus();
  });

  var endpoint = form.dataset.endpoint;
  if (!endpoint) return;

  form.addEventListener("submit", function (event) {
    if (form.dataset.sending === "1") return;
    event.preventDefault();

    var consent = form.querySelector('[name="sms_consent"]');
    var emailValue = value("contact[email]");
    var phoneValue = value("contact[phone]");

    form.dataset.sending = "1";
    if (button) button.disabled = true;
    say("Claiming…");

    fetch(endpoint, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: emailValue,
        phone: phoneValue,
        smsConsent: !!(consent && consent.checked),
        city: (form.querySelector('[name="city"]:checked') || {}).value || "",
        company: value("company"),
        // MUST be one of SIGNUP_SOURCES in lib/email/types.ts ("home-form",
        // "popup", "footer"). This said "home" from 2026-10-05 to 2026-10-18,
        // which the API rejects with a 400 -- and the .catch below then fell
        // through to Shopify's native form, so the signup looked successful
        // to the visitor while the phone and the SMS consent were dropped.
        // A failure this quiet is the reason the fallback must never be the
        // only thing standing between a typo and a lost consent record.
        source: "home-form",
        attribution: attribution()
      })
    })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
      .then(function () {
        // The theme fired no conversion event at all, so signups were
        // invisible in GA4 and Meta. Same event names as the Next.js app so
        // one property sees one event across both hosts.
        try {
          if (window.gtag) window.gtag("event", "generate_lead", { method: "home" });
          if (window.fbq) window.fbq("track", "Lead");
        } catch { /* analytics must never break a signup */ }
        // Swap the form for the confirmation in place: no reload, no
        // redirect. The API has already accepted the signup, so the welcome
        // email goes out in the background exactly as before.
        showConfirmation(form, "api");
      })
      .catch(function () {
        form.dataset.sending = "0";
        if (button) button.disabled = false;
        // Shopify's native customer form REQUIRES an email, so the fallback
        // cannot carry a phone-only signup — it would fail and strand the
        // person on an error page. Tell them instead of pretending.
        if (!emailValue) {
          say("That didn't go through. Try again, or add an email.");
          return;
        }
        // With an email, fall back to Shopify's own capture rather than
        // losing the signup. It drops the phone and the consent, which is
        // why the API path is the one that must keep working. It used to drop
        // the attribution too (a real 10/28 signup arrived tagged only
        // "home-form"), so carry the same src/med/cmp/cnt tags the API writes,
        // plus "fallback" so every API failure is visible in Shopify.
        try {
          var tagsInput = form.querySelector('[name="contact[tags]"]');
          if (tagsInput) tagsInput.value = ["home-form", "fallback"].concat(attributionTags()).join(",");
          if (window.gtag) window.gtag("event", "generate_lead", { method: "fallback" });
          if (window.fbq) window.fbq("track", "Lead");
        } catch { /* never block the fallback */ }
        form.submit();
      });
  });

  // First-touch attribution, read from the URL. Nothing is stored or tracked
  // beyond what the visitor arrived with.
  function attribution() {
    try {
      var q = new URLSearchParams(location.search);
      return {
        utm_source: q.get("utm_source") || "",
        utm_medium: q.get("utm_medium") || "",
        utm_campaign: q.get("utm_campaign") || "",
        utm_content: q.get("utm_content") || "",
        referrer: document.referrer ? new URL(document.referrer).hostname : ""
      };
    } catch {
      return {};
    }
  }

  // Same shape and cleaning as attributionTags() in app/api/subscribe/route.ts.
  function attributionTags() {
    var a = attribution();
    var clean = function (v) {
      return typeof v === "string" ? v.toLowerCase().replace(/[^a-z0-9._-]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 40) : "";
    };
    var tags = [];
    var src = clean(a.utm_source) || clean(a.referrer);
    if (src) tags.push("src:" + src);
    if (clean(a.utm_medium)) tags.push("med:" + clean(a.utm_medium));
    if (clean(a.utm_campaign)) tags.push("cmp:" + clean(a.utm_campaign));
    if (clean(a.utm_content)) tags.push("cnt:" + clean(a.utm_content));
    return tags;
  }
})();

// Offer pop-up (Abel 2026-10-26; timing reset 2026-10-28 from benchmark
// research, brain/DECISIONS.md). The page already has the form, so the pop-up
// is only for people who have ignored it:
//   - opens after 8s (6-10s converts best in Omnisend's 1.24B-display data)
//   - never if the visitor has touched the on-page form, is a member, or came
//     from our own email/SMS links. QR visitors DO get it: the page body
//     never states the 10% (audit 2026-10-28), so the pop-up is where they learn it
//   - once per browser session; 7 days quiet after a dismiss; gone for good
//     after 2 dismissals (conversion falls off from the 3rd view in a week)
//   - never on the fallback "You're in" page.
(function () {
  "use strict";
  var pop = document.getElementById("offer-pop");
  if (!pop || typeof pop.showModal !== "function") return;
  if (document.querySelector(".confirm[data-handled-by]")) return;

  var DELAY = 8000, WEEK = 7 * 24 * 60 * 60 * 1000, MAX_DISMISS = 2;
  var get = function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } };
  var set = function (k, v) { try { localStorage.setItem(k, v); } catch (e) { /* ignore */ } };
  var sget = function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } };
  var sset = function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) { /* ignore */ } };
  if (get("srvd-member")) return;
  if (sget("srvd-offer-session")) return;
  if (Number(get("srvd-offer-dismissed") || 0) >= MAX_DISMISS) return;
  var quietUntil = Number(get("srvd-offer-quiet") || 0);
  if (quietUntil && Date.now() < quietUntil) return;
  var q = new URLSearchParams(location.search);
  if (/email|sms/i.test((q.get("utm_medium") || "") + " " + (q.get("utm_source") || ""))) return;

  var touched = false;
  var form = document.getElementById("member-form");
  if (form) ["focusin", "input", "pointerdown"].forEach(function (ev) {
    form.addEventListener(ev, function () { touched = true; }, { passive: true });
  });

  // After a signup the pop-up never counts as dismissed, whatever closes it.
  var joined = false;
  var close = function (dismissed) {
    if (!pop.open) return;
    pop.close();
    if (dismissed && !joined) {
      set("srvd-offer-dismissed", String(Number(get("srvd-offer-dismissed") || 0) + 1));
      set("srvd-offer-quiet", String(Date.now() + WEEK));
    }
  };
  pop.querySelectorAll("[data-close]").forEach(function (b) { b.addEventListener("click", function () { close(true); }); });
  pop.addEventListener("click", function (e) { if (e.target === pop) close(true); });
  pop.addEventListener("cancel", function () { close(true); });

  // ---- Two-step signup (Brandon 2026-10-30) ----------------------------
  // Same member API as the page form. Step 2 posts the same email again with
  // the phone; the API finds the customer by email and adds the phone and
  // text consent, so it stays one member.
  var endpoint = form && form.dataset.endpoint;
  var email = "";
  var step = function (n) {
    pop.querySelectorAll(".pop-step").forEach(function (el) { el.hidden = el.getAttribute("data-step") !== String(n); });
    var first = pop.querySelector('.pop-step[data-step="' + n + '"] input, .pop-step[data-step="' + n + '"] button');
    if (first) { try { first.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
  };
  var say = function (f, text) {
    var m = f.querySelector(".form-msg");
    if (!m) return;
    m.textContent = text;
    m.hidden = !text;
  };
  var attribution = function () {
    try {
      var p = new URLSearchParams(location.search);
      return {
        utm_source: p.get("utm_source") || "", utm_medium: p.get("utm_medium") || "",
        utm_campaign: p.get("utm_campaign") || "", utm_content: p.get("utm_content") || "",
        referrer: document.referrer ? new URL(document.referrer).hostname : ""
      };
    } catch (e) { return {}; }
  };
  var post = function (payload) {
    if (!endpoint) return Promise.reject(new Error("no endpoint"));
    payload.source = "popup";
    payload.attribution = attribution();
    return fetch(endpoint, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(payload) })
      .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); });
  };

  var emailForm = pop.querySelector("[data-pop-email]");
  if (emailForm) emailForm.addEventListener("submit", function (e) {
    e.preventDefault();
    var input = emailForm.querySelector('[name="email"]');
    var value = (input && input.value || "").trim();
    if (!value || !input.checkValidity()) { say(emailForm, "Add a valid email."); if (input) input.focus(); return; }
    var btn = emailForm.querySelector("button");
    if (btn) btn.disabled = true;
    say(emailForm, "Claiming…");
    post({ email: value, phone: "", smsConsent: false }).then(function () {
      email = value;
      joined = true;
      set("srvd-member", "1");
      try {
        if (window.gtag) { window.gtag("event", "offer_popup_join"); window.gtag("event", "generate_lead", { method: "popup" }); }
        if (window.fbq) window.fbq("track", "Lead");
      } catch (err) { /* analytics must never break a signup */ }
      try { if (window.srvdPopupJoined) window.srvdPopupJoined(); } catch (err) { /* ignore */ }
      say(emailForm, "");
      step(2);
    }).catch(function () {
      if (btn) btn.disabled = false;
      say(emailForm, "That didn't go through. Try again in a moment.");
    });
  });

  var phoneForm = pop.querySelector("[data-pop-phone]");
  if (phoneForm) phoneForm.addEventListener("submit", function (e) {
    e.preventDefault();
    var phone = (phoneForm.querySelector('[name="phone"]').value || "").trim();
    var box = phoneForm.querySelector('[name="sms_consent"]');
    if (!phone) { say(phoneForm, "Add your number, or choose email only below."); return; }
    if (!box || !box.checked) { say(phoneForm, "Tick the box to get texts."); if (box) box.focus(); return; }
    var btn = phoneForm.querySelector("button");
    if (btn) btn.disabled = true;
    say(phoneForm, "Saving…");
    post({ email: email, phone: phone, smsConsent: true }).then(function () {
      try { if (window.gtag) window.gtag("event", "offer_popup_sms"); } catch (err) { /* ignore */ }
      say(phoneForm, "");
      step(3);
    }).catch(function () {
      if (btn) btn.disabled = false;
      say(phoneForm, "That didn't go through. Check the number and try again.");
    });
  });

  var skip = pop.querySelector("[data-pop-skip]");
  if (skip) skip.addEventListener("click", function () { step(3); });
  var done = pop.querySelector("[data-pop-done]");
  if (done) done.addEventListener("click", function () { close(false); });

  setTimeout(function () {
    if (touched) return;
    var active = document.activeElement;
    if (active && active.closest && active.closest("#member-form")) return;
    if (document.querySelector(".confirm")) return;
    sset("srvd-offer-session", "1");
    pop.showModal();
    try { if (window.gtag) window.gtag("event", "offer_popup_shown"); } catch (e) { /* ignore */ }
  }, DELAY);
})();


// Phone + text consent sit behind a toggle on the page form (editorial concept 2026-10-30).
(function () {
  "use strict";
  var t = document.querySelector("[data-more]");
  var box = document.getElementById("more-fields");
  if (!t || !box) return;
  t.addEventListener("click", function () {
    box.hidden = false;
    t.setAttribute("aria-expanded", "true");
    t.hidden = true;
    var f = box.querySelector("input");
    if (f) f.focus();
  });
})();
